import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { observer } from 'mobx-react-lite';
import InterviewResults from 'components/InterviewResults';
import ErrorScreen from 'components/ErrorScreen';
import { interviewApi } from 'api';
import { Interview } from 'types/interview';

/**
 * Публичная страница результатов интервью по расшаренной ссылке.
 * Доступна без авторизации (не обёрнута в ProtectedRoute) — открывается по адресу
 * /shared/results/:id. Данные тянутся через interviewApi.getSharedResultsById.
 */
const SharedResultsPage = () => {
  const { id } = useParams<{ id: string }>();
  const [interview, setInterview] = useState<Interview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setError('Некорректная ссылка на результаты интервью');
      return;
    }

    const load = async () => {
      try {
        const data = await interviewApi.getSharedResultsById(id);
        setInterview(data);
      } catch (e) {
        console.error(e);
        setError('Не удалось загрузить результаты интервью');
      }
    };

    load();
  }, [id]);

  if (error) {
    return <ErrorScreen error={error} />;
  }

  return (
    <Container maxWidth="md" sx={{ height: 'calc(var(--vh, 1vh) * 100)', py: 2 }}>
      <Box sx={{ height: '100%' }}>
        <InterviewResults isShared isCandidate interview={interview} />
      </Box>
    </Container>
  );
};

export default observer(SharedResultsPage);
